import AppLayout from "../Layouts/AppLayout";

export const withAppLayout = (Component) => (
  <AppLayout>
    <Component />
  </AppLayout>
);
